import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { lastValueFrom } from 'rxjs';
import { UsuariosService } from 'src/app/core/services/usuarios.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss']
})
export class RecoverPasswordComponent implements OnInit {


    formRecoverPassword:FormGroup;
    loadingResetPassword: boolean;

    constructor(
      private fb: FormBuilder , 
      private usuarioService: UsuariosService
    ){

    }

    
    ngOnInit(): void {
      this.formRecoverPassword = this.fb.group({
        email: new FormControl('' ,[ Validators.required ])
      })
    }


  async sendRecoverPasswordRequest() {

      if (!this.formRecoverPassword.valid) {
        Swal.fire({
          title: '¡Campo requerido!',
          text: 'El campo de correo o usuario es requerido',
          icon: 'warning',
          confirmButtonText: 'Ok',
        });
        return;
      }

      const userNameOrEmail: string = this.formRecoverPassword.value.email?.trim();

      if (!userNameOrEmail) {
        Swal.fire({
          title: '¡Campo requerido!',
          text: 'El campo de correo o usuario es requerido',
          icon: 'warning',
          confirmButtonText: 'Ok',
        });
        return;
      }

      try {
        
        this.loadingResetPassword  =  true;

        const responseRestorePassword = await lastValueFrom(
          this.usuarioService.resetPassword(userNameOrEmail),
        );
        Swal.fire({
          title: 'Correo enviado',
          text: responseRestorePassword?.message ?? 'Se ha enviado el correo de recuperación.',
          icon: 'success',
          confirmButtonText: 'Ok',
        });

        
        this.formRecoverPassword.reset();
      } catch (error: any) {
        

        const backendMessage =
          error?.error?.message ||
          'No se pudo enviar el correo de recuperación. Intente nuevamente.';

        Swal.fire({
          title: 'Error',
          text: backendMessage,
          icon: 'error',
          confirmButtonText: 'Ok',
        });
      } finally {
        this.loadingResetPassword  =  false
      }
    }
}